/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useCheckAdminPersonOperations = () => useApi(`/v2/admin/check-person-operations`, 'GET', {}, {}, true);

export const useCheckUsername = () => useApi(`/v2/admin/check-username`, 'GET', {}, {}, true);

export const useUpdateAdminPersonOperation = () => useApi(`/v2/admin/update-person-operation`, 'PUT', {}, {}, true);

export const useUpdateAdminUserOperation = () => useApi(`/v2/admin/update-user-operation`, 'PUT', {}, {}, true);

export const useGetAdminAccessRoleList = () => useApi(`/v2/admin/access-role/list`, 'GET', {}, {}, true);

export const useGetAdminAccessGroupList = () => useApi(`/v2/admin/access-group/list`, 'GET', {}, {}, true);

export const useGetAdminEconomicIndexersList = () => useApi(`/v2/admin/economic-indexers/list`, 'GET', {}, {}, true);

export const useGetProductList = () => useApi(`/v2/admin/product/list`, 'GET', {}, {}, true);

export const useGetAdminRoles = () => useApi(`/v2/admin/roles`, 'GET', {}, {}, true);

export const useUpdateAdminAccessRoleOperation = () => useApi(`/v2/admin/update-access-role-operation`, 'PUT', {}, {}, true);

export const useUpdateAdminAccessGroupOperation = () => useApi(`/v2/admin/update-access-group-operation`, 'PUT', {}, {}, true);

export const useGetProductPlanList = () => useApi(`/v2/admin/product-plan/list`, 'GET', {}, {}, true);

export const useGetProductPlanCoverages = (idProductPlan) => useApi(`/v2/admin/product-plan/${idProductPlan}`, 'GET', {}, {}, true);

export const useGetProductPlanCoveragesByIdProduct = (idProduct) => useApi(`/v2/admin/product-plan-coverage/product/${idProduct}`, 'GET', {}, {}, true);

export const useCreateAdminProductOperation = () => useApi(`/v2/admin/product/create`, 'POST', {}, {}, true);

export const useUpdateAdminProductOperation = (idProduct, idOperation) => useApi(`/v2/admin/${idProduct}/product/${idOperation}`, 'PUT', {}, {}, true);

export const useGetProductCoverageList = () => useApi(`/v2/admin/product-coverage/list`, 'GET', {}, {}, true);

export const useUpdateAdminCoverageOperation = () => useApi(`/v2/admin/update-coverage-operation`, 'PUT', {}, {}, true);

export const useUpdateAdminProductPlanOperation = () => useApi(`/v2/admin/update-product-plan-operation`, 'PUT', {}, {}, true);

export const useGeCheckPersonByLegalPersonId = () => useApi(`/v2/admin/check-person-by-legal-person-id`, 'GET', {}, {}, true);

export const useGetAdminDocumentParamsList = () => useApi(`/v2/admin/document-params/list`, 'GET', {}, {}, true);

export const useGetAdminDocumentParams = (idDomain) => useApi(`/v2/admin/document-params/${idDomain}`, 'GET', {}, {}, true);

export const useSaveAdminDocumentParams = (idDomain) => useApi(`/v2/admin/document-params/${idDomain}`, 'PUT', {}, {}, true);
